// Question
import React, { useState } from 'react';
import styles from './Question.module.sass';
import cn from 'classnames';

export interface QuestionProps {
  question: string;
  answer: JSX.Element;
}

const Question: React.FC<QuestionProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen((prev) => !prev);

  return (
    <div className={styles.questionCard}>
      <button className={cn(styles.questionTitle)} onClick={toggleOpen}>
        <span className={styles.question}>{question}</span>
        <span
          className={cn(styles.openButton, {
            [styles.isOpen]: isOpen,
          })}
        >
          <i className="icon-add-filled" />
        </span>
      </button>
      {isOpen && <div className={styles.answer}>{answer}</div>}
    </div>
  );
};

export default Question;
